import { render } from "./Scorecard.vue?vue&type=template&id=a90bf9c8&scoped=true"
import script from "./Scorecard.vue?vue&type=script&lang=js"
export * from "./Scorecard.vue?vue&type=script&lang=js"

import "./Scorecard.vue?vue&type=style&index=0&id=a90bf9c8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90bf9c8"]])

export default __exports__